module.exports = __webpack_public_path__ + "img/index-ico1.7ccae698.png";